import { useQuery } from "@tanstack/vue-query";
import { useGeoMasterDataApi } from "@/features/core-shared/composables/useGeoMasterDataApi";

export function useVenuesMasterdataQuery() {
  const geoMasterDataApi = useGeoMasterDataApi();

  return useQuery({
    queryKey: ["venues-masterdata"],
    queryFn: async () => {
      const { data } = await geoMasterDataApi.getVenues();
      return data;
    },
  });
}
